import { useTranslation } from '@mint-lib/i18n';
import { WarningFilled } from '@mint-lib/icons';
import { Alert, AlertDescription, AlertTitle } from '@mint-lib/tw-components';

export const FileUploadErrorView = () => {
  const { t } = useTranslation('@myn/planning_v2');

  return (
    <>
      <Alert className="flex items-center" severity="error" variant="inline">
        <WarningFilled />
        <AlertTitle>{t('Import failed.')}</AlertTitle>
        <AlertDescription>
          {t('Below is the list of errors detected in the file.')}
        </AlertDescription>
      </Alert>
    </>
  );
};
